// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9883ce2c","453":"ace17a5f","455":"d3dc0b58","977":"a364f2fd"}[chunkId] + ".chunk.js";
};